import React, { useEffect, useRef, useState } from 'react';
import {
    DialogTitle,
    DialogContent, Button, CircularProgress
} from '@material-ui/core';
import { Dialog } from 'components/shared/Dialog';
import styles from './imageModal.module.scss';
import CloseIcon from '@material-ui/icons/Close';
import strings from 'strings';
import { downloadFileByPayload, getAttachmentImage } from '../../../../../actions/applicants';

const SCALE_VALUES = [0.5, 0.75, 1, 1.25, 1.5, 2]; 

const ImageModal = ({ open, onClose, image }) => {
    const [loading, setLoading] = useState(false);
    const [imageFile, setImageFile] = useState(null);
    const [currentScaleIndex, setCurrentScaleIndex] = useState(2); 

    const payloadAttachmentDownload = {
        applicationId: image.applicationId,
        fileId: image.uuid,
        fileName: image.fileName
    };

    const payloadAttachmentDownloadRef = useRef(payloadAttachmentDownload);

    useEffect(() => {
        setCurrentScaleIndex(2);
        if (image && image.uuid) {
            setLoading(true);
            getAttachmentImage({ fileId: image.uuid, applicationId: image.applicationId })()
                .then(blob => {
                    const objectURL = URL.createObjectURL(blob);
                    setImageFile(objectURL);
                    setLoading(false);
                });
        }
    }, [image, payloadAttachmentDownloadRef]);

    function onZoomClickHandler(isZoomIn) {
        setCurrentScaleIndex((prevState) => {
            let newScaleIndex = isZoomIn ? prevState + 1 : prevState - 1;
            return Math.max(0, Math.min(newScaleIndex, SCALE_VALUES.length - 1));
        });
    }

    return (
        <Dialog open={open} fullWidth maxWidth='lg' onClose={onClose}>
            <div>
                <div className={styles.drawerTitle}>
                    <div className={styles.titleContainer}>
                        <DialogTitle>{strings.DOCUMENT_VIEW}</DialogTitle>
                    </div>
                    <div className={styles.actionContainer}>
                        <Button color='primary' variant='contained' onClick={() => downloadFileByPayload(payloadAttachmentDownload)()} className='mr-2'>
                            {strings.DOWNLOAD_IMAGE}
                        </Button>
                        <CloseIcon onClick={onClose} />
                    </div>
                </div>
                <DialogContent>
                    {loading ? (
                        <div className={styles.loading}><CircularProgress size={24} color='inherit' /></div>
                    ) : (
                        imageFile && (
                            <div className={styles.imageContainer}>
                                <img
                                    src={imageFile}
                                    alt='Attachment'
                                    className={styles.image}
                                    style={{
                                        transform: `scale(${SCALE_VALUES[currentScaleIndex]})`,
                                        transformOrigin: 'top center',
                                        transition: 'transform 0.2s ease-in-out'
                                    }}
                                />
                            </div>
                        )
                    )}
                </DialogContent>
            </div>
            <div className={styles.buttonsContainer}>
                <Button
                    color='primary'
                    onClick={() => onZoomClickHandler(true)}
                    variant='contained'
                    className='mr-2'
                    disabled={currentScaleIndex >= SCALE_VALUES.length - 1}
                >
                    {strings.APPLICANT.ATTACHMENTS.PLUS_SYMBOL}
                </Button>
                <Button
                    color='primary'
                    onClick={() => onZoomClickHandler(false)}
                    variant='contained'
                    disabled={currentScaleIndex <= 0}
                >
                    {strings.APPLICANT.ATTACHMENTS.MINUS_SYMBOL}
                </Button>
            </div>
        </Dialog>
    );
};

export default ImageModal;
